import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const useUnreadChats = ({ load: shouldLoad }) => {
  const dispatch = useDispatch();
  const { chats, total, remaining, state } = useSelector(({ unreadChats }) => unreadChats);

  const load = () => dispatch.unreadChats.load();

  useEffect(() => {
    if (shouldLoad) load();
  }, [shouldLoad]);

  useEffect(() => {
    if (state === 'updateAvailable') load();
  }, [state]);

  return {
    chats,
    total,
    remaining,
    load,
  };
};

export default useUnreadChats;
